<template>
  <div class="fill-height">
    <ImageLayout>
      <img
        class="full-width"
        :src="uri"
      />
    </ImageLayout>
    <v-btn
      icon
      elevation="0"
      id="share"
      class="custom-elevation-2 custom-border white-background"
      @click="download()"
    >
      <v-icon>download</v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.full-width {
  max-height: 90vh;
  max-width: 100%;
}

#share {
  position: fixed;
  top: 12px;
  right: 16px;
  z-index: 9;
  margin-top: constant(safe-area-inset-top); /* iOS 11.0 */
  margin-top: env(safe-area-inset-top); /* iOS 11.2 */
}
</style>

<script>
import ImageLayout from '@/layouts/ImageLayout.vue';

export default {
  name: 'Quiz',
  components: {
    ImageLayout,
  },
  computed: {
    uri() {
      if (this.$i18n.locale === 'es') {
        return 'img/iceberg.jpg';
      }
      return 'img/iceberg_en.jpg';
    },
  },
  methods: {
    download() {
      const a = document.createElement('a');
      a.href = this.uri;
      a.download = 'iceberg.jpg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.$track('download', 'iceberg');
    },
  },
};
</script>
